import { createAction } from "redux-actions";

import config from "appConfig";

import {
  GET_CATEGORIES,
  GET_MODULES,
  UPDATE_CURRENT_MODULE,
  GET_FILTERED_CATEGORIES,
  UPDATE_FILTERED_CATEGORIES,
  UPDATE_CURRENT_CATEGORY,
  GET_ROUTES,
  UPDATE_SEARCH_MODE,
  SET_AI_FEEDBACK_MODAL_VISIBLE,
  SET_AI_FEEDBACK_FORM_FILLED,
  SUBMIT_AI_FEEDBACK,
  SET_CONTACT_MODAL_VISIBLE,
  SHOW_POLL_POPUP,
  HIDE_POLL_POPUP
} from "./constants";

import { api, localStorage, notification } from "../../services";
import { CategoriesI } from "../../typings/routesTypes";
import { PollPopupI, routeInterface } from "../../typings/interfaces";
import { LocalStorageKey } from "../../models";

export const getModules = createAction(GET_MODULES, async () => {
  try {
    const modules = await api.Module.list();

    return modules;
  } catch (error) {
    return [];
  }
});

export const getCategories = createAction(GET_CATEGORIES, async () => {
  try {
    const categories: CategoriesI[] = await api.Category.list();

    return categories;
  } catch (error) {
    return [];
  }
});

export const updateCurrentModule = createAction(
  UPDATE_CURRENT_MODULE,
  (module: string, callback: Function) => {
    if (callback) {
      callback();
    }

    return module;
  }
);

export const updateCurrentCategory = createAction(
  UPDATE_CURRENT_CATEGORY,
  (category: string, callback: Function) => {
    if (callback) {
      callback();
    }

    return category;
  }
);

export const getFilteredCategories = createAction(
  GET_FILTERED_CATEGORIES,
  async (queryParams: any) => {
    try {
      const count = await api.Ads.count({ ...queryParams, field: "category" });

      return count;
    } catch (error) {
      return {};
    }
  }
);

export const updateFilteredCategories = createAction(
  UPDATE_FILTERED_CATEGORIES,
  (categories: []) => categories
);


export const setContactModalVisible = createAction(
  SET_CONTACT_MODAL_VISIBLE,
  (visible: boolean) => visible
);

export const showPollPopup = createAction(
  SHOW_POLL_POPUP,
  (poll: PollPopupI) => poll
);

export const hidePollPopup = createAction(HIDE_POLL_POPUP);

export const getRoutes = createAction(
  GET_ROUTES,
  async (pathname: string) => {
    try {
      const routes: routeInterface[] = await api.Routes.list({
        pathname
      });

      return routes;
    } catch (error) {
      return [{}];
    }
  }
);

export const updateSearchMode = createAction(
  UPDATE_SEARCH_MODE,
  (mode: string) => {
    localStorage.setItem(LocalStorageKey.searchMode, {
      mode,
      timestamp: Date.now()
    });

    return mode;
  }
);

export const setAIFeedbackModalVisible = createAction(
  SET_AI_FEEDBACK_MODAL_VISIBLE,
  (visible: boolean) => visible
);

export const setIsAIFeedbackFormFilled = createAction(
  SET_AI_FEEDBACK_FORM_FILLED,
  (filled: boolean) => filled
);

interface AIFeedbackPayload {
  isAiSearchGood: boolean;
  reasons?: number[];
  comment?: string;
  searchQuery?: string;
  isFrontPage?: boolean
}

export const submitAIFeedback = createAction(
  SUBMIT_AI_FEEDBACK,
  async ({ isAiSearchGood, reasons, comment, searchQuery, isFrontPage }: AIFeedbackPayload) => {
    const decodedSearchQuery = searchQuery && decodeURIComponent(searchQuery);
    const decodedSearchQueryParsed = decodedSearchQuery && JSON.parse(decodedSearchQuery);

    try {
      await api.Survey.aiSearchFeedback({
        isAiSearchGood,
        reasons,
        comment,
        isFrontPage,
        searchQuery: decodedSearchQueryParsed && decodedSearchQueryParsed.searchText
      });

      notification.show("Hvala na povratnoj informaciji!");

      return { success: true };
    } catch (error) {
      notification.showError("Greška pri slanju povratne informacije.");

      return { success: false };
    }
  }
);


// WEBPACK FOOTER //
// ./src/containers/App/actions.ts